﻿(function (angular, setTimeout) {
  "use strict";

  var GFV_FAST_TRANSITION_DURATION_MS = 1250;
  var LOCATION_INDICATOR_TRANSITION_DURATION_MS = 350;
  var OPTIONS_TAB_REMOVE_OVERFLOW_HIDDEN_DELAY_MS = 500;

  angular.module("Toyota").directive("tyFinanceOptions", [
    "$rootScope",
    "SitecoreAnalytics",
    function ($rootScope, SitecoreAnalytics) {
      var controller = [
        "$scope",
        "$parse",
        "$attrs",
        "PricingPageAnalyticsService",
        "PricingSendToDealerAutofill",
        function (
          $scope,
          $parse,
          $attrs,
          PricingPageAnalyticsService,
          PricingSendToDealerAutofill
        ) {
          var financeCalcVariables = [
            "financeCalculator.dialReady",
            "financeCalculator.currentVariable",
            "financeCalculator.calculationUpdated",
            "financeCalculator.variables.deposit",
            "financeCalculator.variables.kmsPerYear",
            "financeCalculator.calculation.GFV",
            "financeCalculator.calculation.isCampaign",
            "financeCalculator.calculation.numberOfPayments",
            "financeCalculator.calculation.monthlyPayment",
            "financeCalculator.calculation.kmsPerLoanTerm",
          ];
          var financeOptionsBaseVariables = {
            GFV: "- -",
            deposit: "- -",
            kmsPerYear: "- -",
            dialReady: false,
            calculationUpdated: false,
            isCampaign: false,
            numberOfPayments: 0,
            monthlyPayment: "- -",
            kmsPerLoanTerm: "- -",
          };

          $scope.financeOptions = $scope.financeOptions || {};
          $scope.financeOptions.showingFinance = false;
          $scope.financeOptions.showingFsl = false;
          $scope.financeOptions.showingCash = false;
          $scope.financeOptions.showVariablesAndGFV = false;
          $scope.financeOptions.isGFVHidden = false;
          $scope.financeOptions.loading = true;
          $scope.financeOptions.hasError = false;
          $scope.financeOptions.calculatorOpen = false;
          $scope.financeOptions.variables = financeOptionsBaseVariables;
          $scope.financeOptions.disclaimerTitle = "";

          $scope.financeOptions.showFinanceOptionsCash = function (
            transitionless
          ) {
            angular
              .element('[data-js="ty-pricing-financeoptions-cash"]')
              .addClass("is-overflow-hidden");
            angular
              .element('[data-js="ty-pricing-info-location"]')
              .addClass("is-location-hidden");

            PricingPageAnalyticsService.setFinanceSetting("cash");

            setTimeout(function () {
              $scope.financeOptions.isTransitionless = transitionless;
              $scope.financeOptions.showingFinance = false;
              $scope.financeOptions.showingFsl = false;
              $scope.financeOptions.showingCash = true;
              updatePricingSendToDealerAutofillEnquiryType();
              $scope.$apply();
            }, 0);

            angular
              .element('[data-js="ty-pricing-info-body"]')
              .removeClass("is-finance-calculated");

            $scope.financeOptions.setFinanceOptionsTabTransition(
              '[data-js="ty-pricing-financeoptions-cash"]',
              transitionless
            );
          };

          $scope.financeOptions.showFinanceOptionsFinance = function (
            transitionless
          ) {
            angular
              .element('[data-js="ty-pricing-financeoptions-finance"]')
              .addClass("is-overflow-hidden");
            angular
              .element('[data-js="ty-pricing-info-location"]')
              .addClass("is-location-hidden");

            PricingPageAnalyticsService.setFinanceSetting("finance");

            setTimeout(function () {
              $scope.financeOptions.isTransitionless = transitionless;
              $scope.financeOptions.showingFinance = true;
              $scope.financeOptions.showingFsl = false;
              $scope.financeOptions.showingCash = false;
              updatePricingSendToDealerAutofillEnquiryType();

              if (!$scope.financeCalculator.hasInitialData) {
                $scope.financeCalculator.setBaseData();
              }

              $scope.$apply();
            });

            if ($scope.financeOptions.variables.hasValidFinanceData) {
              angular
                .element('[data-js="ty-pricing-info-body"]')
                .addClass("is-finance-calculated");
            }

            $scope.financeOptions.setFinanceOptionsTabTransition(
              '[data-js="ty-pricing-financeoptions-finance"]',
              transitionless
            );
          };

          $scope.financeOptions.showFinanceOptionsFsl = function (
            transitionless
          ) {
            angular
              .element('[data-js="ty-pricing-financeoptions-fsl"]')
              .addClass("is-overflow-hidden");
            angular
              .element('[data-js="ty-pricing-info-location"]')
              .addClass("is-location-hidden");

            PricingPageAnalyticsService.setFinanceSetting("fsl");

            setTimeout(function () {
              $scope.financeOptions.isTransitionless = transitionless;
              $scope.financeOptions.showingFinance = false;
              $scope.financeOptions.showingFsl = true;
              $scope.financeOptions.showingCash = false;

              if (!$scope.financeCalculator.hasInitialData) {
                $scope.financeCalculator.setBaseData();
              }

              $scope.$apply();
            }, 0);

            angular
              .element('[data-js="ty-pricing-info-body"]')
              .removeClass("is-finance-calculated");

            $scope.financeOptions.setFinanceOptionsTabTransition(
              '[data-js="ty-pricing-financeoptions-fsl"]',
              transitionless
            );
          };

          $scope.financeOptions.setFinanceOptionsTabTransition = function (
            optionsTab,
            transitionless
          ) {
            if (!transitionless) {
              setTimeout(function () {
                angular
                  .element('[data-js="ty-pricing-info-location"]')
                  .removeClass("is-location-hidden");
              }, LOCATION_INDICATOR_TRANSITION_DURATION_MS);
              setTimeout(function () {
                angular.element(optionsTab).removeClass("is-overflow-hidden");
              }, OPTIONS_TAB_REMOVE_OVERFLOW_HIDDEN_DELAY_MS);
            } else {
              angular
                .element('[data-js="ty-pricing-info-location"]')
                .removeClass("is-location-hidden");
              angular.element(optionsTab).removeClass("is-overflow-hidden");
            }
          };

          $scope.financeOptions.triggerFinanceOptionsFinanceAnalytics =
            function () {
              PricingPageAnalyticsService.setFinanceSetting("finance");
              $parse($attrs.tyFinanceOptionsOnFinanceTabClickAnalytics)($scope);
            };

          $scope.financeOptions.triggerFinanceOptionsCashAnalytics =
            function () {
              $parse($attrs.tyFinanceOptionsOnCashTabClickAnalytics)($scope);
            };

          $scope.financeOptions.triggerFinanceOptionsFslAnalytics =
            function () {
              PricingPageAnalyticsService.setFinanceSetting("full service lease");
              $parse($attrs.tyFinanceOptionsOnFslTabClickAnalytics)($scope);
            };

          $scope.init = function () {
            PricingSendToDealerAutofill.clear();
            updatePricingSendToDealerAutofillEnquiryType();
          };

          $scope.init();

          $scope.$watchGroup(
            ["financeCalculator.isLoading", "financeCalculator.isLoaded"],
            function () {
              $scope.financeOptions.loading = !(
                $scope.financeCalculator.isLoaded &&
                !$scope.financeCalculator.isLoading
              );
            }
          );

          $scope.$watch("financeCalculator.hasError", function () {
            $scope.financeOptions.hasError =
              $scope.financeCalculator.hasError &&
              !$scope.financeOptions.calculatorOpen;
          });

          $scope.financeOptions.toggleGFV = function (forceOpen) {
            var configuredGFVState =
              typeof forceOpen === "undefined"
                ? $scope.financeOptions.isGFVHidden
                : forceOpen;
            var $gfv = angular.element(
              '.ty-pricing-sticky-footer [data-js="ty-pricing-financeoptions-gfv"]'
            );
            if (configuredGFVState) {
              $gfv.addClass("is-fast-transition").removeClass("is-hidden");
              setTimeout(function () {
                $gfv.removeClass("is-fast-transition");
              }, GFV_FAST_TRANSITION_DURATION_MS);
            } else {
              $gfv.addClass("is-hidden");
            }

            $scope.financeOptions.isGFVHidden = !configuredGFVState;
          };

          $scope.financeOptions.showCalculatorModal = function (goalId) {
            SitecoreAnalytics.triggerGoal(goalId);
            // Open Modal
            $scope.financeOptions.calculatorOpen = true;
            $rootScope.$broadcast("modal-open", "finance-calculator");
          };

          function updatePricingSendToDealerAutofillEnquiryType() {
            if (
              $scope.financeOptions.showingFinance &&
              $scope.financeOptions.variables.hasValidFinanceData
            ) {
              PricingSendToDealerAutofill.setEnquiryTypeToFinance();
              $scope.financeOptions.showSendToDealer = true;
            } else {
              PricingSendToDealerAutofill.setEnquiryTypeToCash();
              $scope.financeOptions.showSendToDealer = false;
            }
          }

          $scope.$watchGroup(financeCalcVariables, function (newVal, oldVal) {
            if (newVal !== oldVal) {
              var watchResults = {};
              financeCalcVariables.forEach(function (value, index) {
                watchResults[value.split(".").pop()] = newVal[index];
              });
              $scope.financeOptions.variables.isCampaign =
                watchResults.isCampaign;

              $scope.financeOptions.variables.hasValidFinanceData =
                watchResults.isCampaign ||
                (watchResults.dialReady && watchResults.calculationUpdated);

              if ($scope.financeOptions.variables.hasValidFinanceData) {
                $scope.financeOptions.variables.GFV = watchResults.GFV;
                $scope.financeOptions.variables.deposit = watchResults.deposit;
                $scope.financeOptions.variables.kmsPerYear =
                  watchResults.kmsPerYear;
                $scope.financeOptions.variables.numberOfPayments =
                  watchResults.numberOfPayments;
                $scope.financeOptions.variables.monthlyPayment =
                  watchResults.monthlyPayment;
                $scope.financeOptions.variables.kmsPerLoanTerm =
                  watchResults.kmsPerLoanTerm;
              }

              if (
                !watchResults.isCampaign &&
                !watchResults.calculationUpdated
              ) {
                $scope.financeOptions.showVariablesAndGFV = false;
              } else {
                $scope.financeOptions.showVariablesAndGFV = true;
              }

              updatePricingSendToDealerAutofillEnquiryType();
            }
          });

          $scope.$on("modal-close", function (event, target) {
            if (target === "finance-calculator") {
              $scope.financeOptions.calculatorOpen = false;
            }
          });
        },
      ];

      return {
        scope: false,
        restrict: "A",
        controller: controller,
        bindToController: true,
        controllerAs: "tyFinanceOptionsController",
        link: function ($scope, $element, $attrs) {
          $scope.financeOptions.gfvToastMessage = $attrs.gfvToastMessage;
        },
      };
    },
  ]);
})(window.angular, window.setTimeout);
